import { render, staticRenderFns } from "./Withdrawals.vue?vue&type=template&id=02e99dd0&scoped=true"
import script from "./Withdrawals.vue?vue&type=script&lang=js"
export * from "./Withdrawals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e99dd0",
  null
  
)

export default component.exports